<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{title}}</h4>
	</div>
</div>

<div class="card-box clearfix">
	<div class="col-xs-12">
		<p>{{{content}}}</p>
	</div>
<div>
